<template>
  <custom-dialog :visible="visible" width="680px" class="project-site-dialog" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="input-container">
        <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
          <el-row>
            <el-col>
              <el-form-item :label="$t('Common.com_location_name')" prop="locationId">
                <custom-select
                  filterable
                  url="portalLocationList"
                  :model="form"
                  v-model="form.locationId"
                  :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName',isBasicGoal:'isBasicGoal'} }"
                  :placeholder="$t('Common.com_please_select')"
                  theme="yellow"
                >
                </custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('Common.com_site_name')" prop="siteName">
                <el-input v-model="form.siteName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="cleanAreaDay">
                <el-input v-model="form.goalArea" :disabled="form.isBasicGoal"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('location_site_dialog.qjscmint')">
                <el-input v-model="form.goalTime" :disabled="form.isBasicGoal"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        isBasicGoal: '',
        locationName: '', // 项目名称
        locationId: '', // 项目Id
        siteId: '', // 编辑时必填
        siteName: '', // 区域名称
        timezone: '', // 时区
        goalArea: '', // 清洁面积
        goalTime: '', // 清洁时长
        showSubsidiary: '',
        orgId: '',
      },
      dialogVisible: false,
      dialogModel: {},
      locationInfo: {},
      floorInfo: {},
    };
  },
  computed: {
    cleanAreaDay() {
      return this.$t('location_site_dialog.qjmjot', [this.$formatLenUnit()]);
    },
    rules() {
      return {
        locationId: [
          {
            required: true,
            message: this.$t('location_site_dialog.xmmcbx'),
            trigger: 'blur'
          }
        ],
        siteName: [
          {
            max: 30,
            message: this.$t('location_site_dialog.cdbncg30gzf'),
          }
        ],
      };
    },
  },
  mounted: function () {
    this.initForm();
    // this.getFuncView(this.isPortal ? '/portal/device/project' : '/project');
  },
  methods: {
    initForm() {
      this.$setFormatData(this.form, this.model.data);
      if (this.model.type === 'edit') {
        this.getSiteInfo();
      }
    },
    getSiteInfo() {
      this.$getJSON(apis.locationSiteInfo, { siteId: this.model.data.id }).then((res) => {
        const data = res.data || {};
        this.$setFormatData(this.form, data);
      });
    },
    updateFloorList() {
      this.$refs.floor.getSelectList();
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      if (this.model.type === 'add') {
        this.add();
      } else {
        this.edit();
      }
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationSiteUpdate, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success');
          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationSiteAdd, this.form, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.$emit('success');
          });
        }
      });
    }
  },
};
</script>

<style lang="scss">
</style>
